export default "__VITE_ASSET__DcSF8a_X__"